import { render } from "./DraggableTable.vue?vue&type=template&id=62caf7ab&scoped=true"
import script from "./DraggableTable.vue?vue&type=script&lang=ts"
export * from "./DraggableTable.vue?vue&type=script&lang=ts"

import "./DraggableTable.vue?vue&type=style&index=0&id=62caf7ab&lang=scss"
import "./DraggableTable.vue?vue&type=style&index=1&id=62caf7ab&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-62caf7ab"

export default script